import React from 'react';
import { XCircleIcon } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
const painPoints = ['Domingos perdidos buscando ejercicios de MRUV o circuitos eléctricos que se vean bien al imprimir.', 'Clases desconectadas porque no tenés una secuencia clara entre lo que ven en 1° y lo que necesitan en 6°.', 'La Feria de Ciencias que se viene y no tenés ni un proyecto armado, ni los materiales, ni la guía para el jurado.', 'El estrés del cierre de trimestre: horas redactando exámenes distintos para que nadie se copie y notas para 200 alumnos.', 'Los alumnos que te preguntan "¿profe, esto para qué sirve?" y vos no tenés un ejemplo cotidiano listo para responder.'];
export function PainPointsSection() {
  return <section className="py-10 md:py-20 px-4 bg-white" data-id="element-199">
      <div className="max-w-4xl mx-auto" data-id="element-200">
        <h2 className="text-3xl md:text-4xl font-black text-center text-brand-dark mb-8 md:mb-12" data-id="element-201">
          Si sos docente de Física en secundaria,{' '}
          <br className="hidden md:block" data-id="element-202" />
          <span className="text-brand-orange" data-id="element-203">
            esto te va a sonar familiar:
          </span>
        </h2>

        <div className="space-y-4 md:space-y-6 mb-8 md:mb-12 bg-red-50 p-5 md:p-8 rounded-2xl border border-red-100" data-id="element-204">
          {painPoints.map((point, index) => <div key={index} className="flex items-start gap-4" data-id="element-205">
              <XCircleIcon className="w-8 h-8 text-red-500 flex-shrink-0 mt-1" data-id="element-206" />
              <p className="text-xl font-medium text-gray-800" data-id="element-207">{point}</p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-208">
          <h3 className="text-2xl md:text-3xl font-bold text-brand-dark mb-6 md:mb-8" data-id="element-209">
            ¿Cuántos domingos más vas a sacrificar?
          </h3>
          <div className="max-w-xl mx-auto" data-id="element-210">
            <CTAButton text="→ QUIERO DEJAR DE IMPROVISAR" href="#compra" data-id="element-211" />
          </div>
        </div>
      </div>
    </section>;
}